export namespace ImGroupStateActions {
  export class Load {
    public static readonly type = '[ImGroup] Load';
  }

  export class ReloadGroup {
    public static readonly type = '[ImGroup] Reload';

    constructor(public readonly groupId: string) {}
  }

  export class LoadGroupIfNotLoaded {
    public static readonly type = '[ImGroup] Load Group If Not Loaded';

    constructor(public readonly groupId: string) {}
  }

  export class DeleteGroup {
    public static readonly type = '[ImGroup] Delete Group';

    constructor(public readonly groupId: string) {}
  }

  export class DeleteGroupMember {
    public static readonly type = '[ImGroup] Delete Group Member';

    constructor(
      public readonly groupId: string,
      public readonly memberId: string,
    ) {}
  }
}
